import { Provider } from '../types/shared.types';

/**
 * Providers offered in the "Add Custom Price" modal (menu items and modifiers,
 * both the live menu and brand templates). Kept as one list because all four
 * copies of that modal must offer the same set - not every `Provider` is
 * orderable, so this is deliberately narrower than `Object.values(Provider)`.
 */
export const CUSTOM_PRICE_PROVIDERS: Provider[] = [
  Provider.doordash,
  Provider.grubhub,
  Provider.ubereats,
  Provider.gloriafood,
  Provider.doordashPos,
  Provider.grubhubPos,
  Provider.delivery,
  Provider.bytes,
  Provider.vGrubs,
  Provider.kanekt365,
  Provider.devourNow,
];
